import { Entity } from '@backstage/catalog-model';
import { EntityFilter } from '@backstage/plugin-catalog-react';

/**
 * Custom EntityFilter implementations for the four user-identity annotations
 * surfaced by PAT-422. All four follow the same shape as the stock
 * EntityTagFilter:
 *
 *   - filterEntity:       client-side predicate (used for the in-page filter)
 *   - getCatalogFilters:  backend filter (used by getEntityFacets and the
 *                         catalog query itself)
 *   - toQueryValue:       URL state serialisation
 *
 * Annotation keys carry forward-slashes (e.g. `user/role`). Backstage's
 * dot-notation filter syntax treats anything after `metadata.annotations.`
 * as the literal annotation key, so `metadata.annotations.user/role` is the
 * correct facet path. Same pattern stock uses for `backstage.io/orphan`.
 */

/** Build a filter class for a single user/* annotation. */
function buildAnnotationFilter(annotationKey: string) {
  return class implements EntityFilter {
    constructor(readonly values: string[]) {}

    filterEntity(entity: Entity): boolean {
      const value = entity.metadata.annotations?.[annotationKey];
      return value !== undefined && this.values.includes(value);
    }

    getCatalogFilters(): Record<string, string | string[]> {
      return { [`metadata.annotations.${annotationKey}`]: this.values };
    }

    toQueryValue(): string[] {
      return this.values;
    }
  };
}

export const EntityUserRoleFilter = buildAnnotationFilter('user/role');
export const EntityUserDepartmentFilter = buildAnnotationFilter('user/department');
export const EntityUserOfficeFilter = buildAnnotationFilter('user/office');
export const EntityUserCountryFilter = buildAnnotationFilter('user/country');
